import EmptyView from 'general/components/Others/EmptyView';
import AppColors from 'general/constants/AppColors';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Table } from 'antd';
import tableStyle from './tableStyle';
import tableStyleAction from './tableStyleAction';
import AppConfigs from 'general/constants/AppConfigs';

KTTable.propTypes = {
  columns: PropTypes.array,
  items: PropTypes.array,
  disabledItems: PropTypes.array,
  preselectedItems: PropTypes.array,
  selectableRows: PropTypes.bool,
  striped: PropTypes.bool,
  compactGrid: PropTypes.bool,
  loading: PropTypes.bool,
  onClickedRow: PropTypes.func,
  onDoubleClickedRow: PropTypes.func,
  onSelectedRowsChanged: PropTypes.func,
  noDataComponent: PropTypes.element,
  scrollable: PropTypes.bool,
  showBorderBottom: PropTypes.bool,
  hasActionColumn: PropTypes.bool,
  groupHeader: PropTypes.bool
};

function KTTable({
  columns = [],
  items = [],
  disabledItems = [],
  preselectedItems = [],
  selectableRows = true,
  striped = true,
  compactGrid = false,
  loading = false,
  onClickedRow,
  onDoubleClickedRow,
  onSelectedRowsChanged,
  noDataComponent,
  scrollable = false,
  showBorderBottom = false,
  hasActionColumn = true,
  groupHeader = false,
}) {
  const isHideBike = AppConfigs.env.hideBike == 1;
  const filteredColumns = isHideBike ? columns.filter(col => col.id !== 'VEHICLE_TYPE') : columns;

  useEffect(() => {
    if (!groupHeader) {
      const dataTable = document.querySelector('.rdt_Table');
      if (dataTable) {
        dataTable.addEventListener('dragstart', (event) => {
          event.preventDefault();
        });
      }

      return () => {
        if (dataTable) {
          dataTable.removeEventListener('dragstart', (event) => {
            event.preventDefault();
          });
        }
      };
    }
  }, [groupHeader]);

  const rowDisabledCriteria = (row) => {
    return disabledItems?.map((item) => item.id)?.includes(row.id);
  };

  const rowPreselectedCriteria = (row) => {
    return preselectedItems?.map((item) => item.id)?.includes(row.id);
  };

  const handleSelectedRowsChanged = ({ selectedRows }) => {
    if (onSelectedRowsChanged) {
      onSelectedRowsChanged(selectedRows);
    }
  };

  const antRowSelection = selectableRows
    ? {
      selectedRowKeys: preselectedItems?.map((item) => item.id) || [],
      getCheckboxProps: (record) => ({
        disabled: disabledItems?.map((item) => item.id)?.includes(record.id),
      }),
      onChange: (selectedRowKeys, selectedRows) => {
        if (onSelectedRowsChanged) {
          onSelectedRowsChanged(selectedRows);
        }
      },
    }
    : null;

  if (groupHeader) {
    return (
      <div
        style={{
          borderRadius: '5px',
          overflow: scrollable ? 'auto' : 'hidden',
        }}
        className={items.length === 0 ? 'no-data-table' : ''}
      >
        <Table
          className={items.length === 0 ? 'no-data-table' : 'kt-table-bordered'}
          columns={filteredColumns}
          dataSource={items}
          rowSelection={antRowSelection}
          loading={loading}
          locale={{ emptyText: noDataComponent ?? <EmptyView /> }}
          pagination={false}
          scroll={scrollable ? { x: 'max-content' } : undefined}
          onRow={(record) => ({
            onClick: () => onClickedRow?.(record),
            onDoubleClick: () => onDoubleClickedRow?.(record),
          })}
          rowKey="id"
          bordered={showBorderBottom}
          showHeader={items.length > 0}
        />
      </div>
    );
  }

  return (
    <div
      className="overflow-hidden"
      style={{
        borderLeft: items.length > 0 ? `1px solid ${AppColors.gray[300]}` : '',
        borderRight: items.length > 0 ? `1px solid ${AppColors.gray[300]}` : '',
        borderRadius: '5px',
      }}
    >
      <DataTable
        columns={filteredColumns}
        data={items}
        customStyles={hasActionColumn ? tableStyleAction : tableStyle}
        responsive={true}
        noHeader
        selectableRows={selectableRows}
        striped={striped}
        dense={compactGrid}
        progressPending={loading}
        selectableRowDisabled={rowDisabledCriteria}
        selectableRowSelected={rowPreselectedCriteria}
        noDataComponent={noDataComponent ?? <EmptyView />}
        onSelectedRowsChange={handleSelectedRowsChanged}
        onRowClicked={onClickedRow}
        onRowDoubleClicked={onDoubleClickedRow}
        pointerOnHover={true}
        highlightOnHover={false}
        selectableRowsHighlight={true}
      />
    </div>
  );
}

export default KTTable;